import ctl from '@netlify/classnames-template-literals'
import { CheckIcon, MinusIcon } from 'lucide-react'
import React from 'react'

export interface SelectionCheckboxProps {
	checked: boolean
	indeterminate?: boolean
	onToggle: (event: React.MouseEvent) => void
	label: string
	alwaysVisible?: boolean
}

export function SelectionCheckbox({
	checked,
	indeterminate = false,
	onToggle,
	label,
	alwaysVisible = false,
}: SelectionCheckboxProps) {
	const active = checked || indeterminate

	return (
		<button
			type="button"
			role="checkbox"
			aria-checked={indeterminate ? 'mixed' : checked}
			aria-label={label}
			onClick={(event) => {
				event.stopPropagation()
				onToggle(event)
			}}
			className={ctl(`
				size-5 shrink-0 rounded border flex items-center justify-center
				transition-all cursor-pointer
				focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-500
				${
				active
					? 'bg-purple-600 border-purple-600 text-white'
					: 'bg-white border-grey-300 hover:border-purple-400'
			}
				${
				active || alwaysVisible ? 'opacity-100' : 'opacity-0 group-hover:opacity-100 focus-visible:opacity-100'
			}
			`)}
		>
			{indeterminate
				? <MinusIcon className="size-3.5" />
				: checked
				? <CheckIcon className="size-3.5" />
				: null}
		</button>
	)
}

export default SelectionCheckbox
